import { useTranslation } from "react-i18next";
import Spinner from "@/components/Spinner";

interface ContractorVisitLoaderProps {
  reason?: string;
}

export const ContractorVisitLoader = ({
  reason,
}: ContractorVisitLoaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center h-64 space-y-4">
      <Spinner />
      <p className="text-sm text-muted-foreground">
        {reason
          ? t(`projectContractorVisits.loadingStates.${reason}`)
          : t("projectContractorVisits.loadingStates.loading")}
      </p>
    </div>
  );
};
